/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { jsx } from '@compiled/react';

import { Anchor } from '@atlaskit/primitives/compiled';

import type { ExtensionComponents } from '../common/utils/extension-components-context/types';

const CardAsLink = ({ url }: { url: unknown }) =>
	typeof url === 'string' ? <Anchor href={url}>{url}</Anchor> : null;

export const RendererCardsAsLinksExtension: Pick<ExtensionComponents, 'rendererNodeComponents'> = {
	rendererNodeComponents: {
		inlineCard: (props) => <CardAsLink url={props.url} />,
		blockCard: (props) => <CardAsLink url={props.url} />,
		embedCard: (props) => <CardAsLink url={props.url} />,
	},
};
